import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/user',
  redirect: '/user/userList',
  component: SubLayout,
  children: [
    {
      path: 'userList',
      name: 'userList',
      meta: {
        title: '会员中心'
      },
      component: () => import('@/views/user/UserList')
    },
    {
      path: 'setPassword/:username',
      name: 'setPassword',
      meta: {
        title: '设置密码'
      },
      component: () => import('@/views/user/SetPassword')
    },
    {
      path: 'walletList',
      name: 'walletList',
      meta: {
        title: '钱包管理'
      },
      component: () => import('@/views/user/WalletList')
    },
    {
      path: 'storeList',
      name: 'storeList',
      meta: {
        title: '店铺管理'
      },
      component: () => import('@/views/user/StoreList')
    }
  ]
}

export default routes
